import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Layout from '../../components/layout/Layout'
import FormAgregar from '../../components/asignaturas/FormAgregar'
import { createAsignatura, seleccionarPhotoAsignatura, updateNameAsignatura } from '../../helpers/asignaturas'
import { useForm } from '../../hooks/ useForm'
import CardAsignatura from '../../components/asignaturas/CardAsignatura'
import { startNewAsignatura, updateImagenAsig, updateNameAsig } from '../../reducer/AsignaturasReducer'
import {urlImgAsig} from '../../directories/collections'
const AsignaturasView = () => {
    const dispatch = useDispatch();
    const {asignaturas} = useSelector(state => state.asignaturas)
    const [value, handleInputChange, reset] = useForm({name: ''})
    const {email} = useSelector(state => state.perfil)
    const [error, setError] = useState(false)
    const [message, setMessage] = useState('')
    const [loading, setLoading] = useState(false)

    const isFormValid = (name) =>{
        if (name.trim().length === 0) {
            setError(true)
            setMessage('Nombre de la asignatura es requerida')
            return false
        }
        return true;
    }
    
    const handleSubmit = (name) => {
        setLoading(true)
        if (!isFormValid(name)) {
            return 
        }
        createAsignatura(email,name)
        .then(response => {
            dispatch(startNewAsignatura(response.id,name,urlImgAsig.url))
            setLoading(false)
            reset()
        })
        .catch(e => {
            console.log(e)
        })
    }

    const handleUpdateAsig = (name, id) => {
        setLoading(true)
        if (!isFormValid(name)) {
            return 
        }
        updateNameAsignatura(email,id,name)
        .then(() => {
            dispatch(updateNameAsig(id,name))
            setLoading(false)
        })
    }

    const handleUpdateImg = (img,id,name) => {
        setLoading(true)
        seleccionarPhotoAsignatura(img,id,email,name)
        .then(() => {
            let url = URL.createObjectURL(img)
            dispatch(updateImagenAsig(id,url))
            setLoading(false)
        })
    }

    return (
        <Layout>
            <h1 className='title'>Asignaturas</h1>
            <FormAgregar
                error={error}
                message={message}
                loading={loading}
                funcion={handleSubmit}
                value={value}
                change={handleInputChange}
                placeholder='Nombre de la asignatura'
            />
            <div className='container_grid_asig'>
                {
                    asignaturas?.map((asignatura, index) => (
                        <CardAsignatura 
                            key={index}
                            data={asignatura}
                            funcionUpName={handleUpdateAsig}
                            funcionUpImg={handleUpdateImg}
                            loading={loading}
                        />
                    ))
                }
                
            </div>
        </Layout>
    )
}

export default AsignaturasView
